import { mergeClassnames } from '@heathmont/moon-core-tw';
import type Position from '@heathmont/moon-core-tw/lib/tooltip/private/types/Position';
import Img from '~/client/shared/images/Img';
import getCdnImg from '~/shared/cdn/getCdnImg';
import TooltipContent from './TooltipContent';
import TournamentTooltip from './TournamentTooltip';

type Props = {
  type?: string;
  bgColor?: string;
  centerTooltip?: boolean;
  tooltipPosition?: Position;
  isGameBanner?: boolean;
  isCurrentTournaments?: boolean;
};

const TournamentTypeIndicator: FC<Props> = ({
  type,
  bgColor,
  tooltipPosition,
  isGameBanner,
  isCurrentTournaments,
}) => {
  if (type !== undefined && type !== null && typeof type !== 'string') {
    // eslint-disable-next-line no-console
    console.log('For some reason tournament type is', typeof type, type);
  }
  const typeTranslateString = type?.replaceAll(' ', '-');
  return (
    <div
      className="relative"
      data-testid="tournament-type"
      aria-describedby="tournament-type-tooltip"
    >
      <TournamentTooltip
        tooltipPosition={tooltipPosition}
        isCurrentTournaments={isCurrentTournaments}
        trigger={
          <Img
            height={isGameBanner ? 16 : 32}
            width={isGameBanner ? 16 : 32}
            src={getCdnImg(`tournaments/icons/${typeTranslateString}.svg`)}
            className={mergeClassnames(
              'relative w-8 h-8 max-w-none cursor-pointer rounded-full shadow-[rgb(15_22_31_/10%)_0px_0px_0.75rem_0px]',
              isGameBanner && 'h-4 w-4',
              bgColor && bgColor,
            )}
          />
        }
      >
        <TooltipContent typeTranslateString={typeTranslateString} />
      </TournamentTooltip>
    </div>
  );
};

export default TournamentTypeIndicator;
